import { useSyncExternalStore } from 'react'
import userStoredData from './userStoredData'

// How the current platform session signed in (see userStoredData), re-rendering whenever the session
// changes in this page: login, logout, or the Graph mailbox address patched in after an Azure login.
export default function useSessionAuth() {
  return useSyncExternalStore(userStoredData.subscribe, userStoredData.getAuth)
}
